import React from 'react'

import ResumePreviewLineGuidesContent from './ResumePreviewLineGuidesContent'

export { ResumePreviewFontSizeLegend } from './ResumePreviewFontSizeLabelsContent'

type ResumePreviewDebugContentProps = {
  lineGuides?: boolean
  guideScopeSelector?: string
  children: React.ReactNode
}

/** Line guides on preview slice; font-size badges are a separate overlay (see ResumePreviewFontSizeLabelsOverlay). */
export default function ResumePreviewDebugContent({
  lineGuides = false,
  guideScopeSelector,
  children,
}: ResumePreviewDebugContentProps) {
  return (
    <ResumePreviewLineGuidesContent lineGuides={lineGuides} guideScopeSelector={guideScopeSelector}>
      {children}
    </ResumePreviewLineGuidesContent>
  )
}
